<template>
  <div class="content">
    <div class="notice-title" v-if="type=='1'">
    	通知公告
    </div>
    <div class="notice-title" v-if="type=='2'">
      		政策文件
    </div>
    <div class="list">
      <div
        class="notice-item"
        v-for="(item, index) in noticeList"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="left-name">
          <img src="@/assets/images/new/dot.png" alt="" />
          <span>{{item.titile}}</span>
        </div>
        <div class="right-date">{{getTime(item.createTime)}}</div>
      </div>
    </div>
    <div class="page" v-if="total>0">
      <a-pagination v-model="current" @change="onChange" :total="total" />
    </div>
  </div>
</template>

<script>
import { getNoticeList} from "@/api/index";
export default {
  name: "DeclarationWebList",
  data() {
    return {
      current: 1,
      total: 0,
      noticeList: [],
      type:1,
    };
  },
  created(){
  	// this.type=this.$route.query.type;
  	this.getlist();
  },
  mounted() {
  },
  methods: {
  	onChange(page, pageSize){
  		this.current=page;
  		this.getlist();
  	},
  	getTime(time){
  		if(time!=''){
  			return time.substring(0,10);
  		}else{
  			return '';
  		}
  	},
  	getlist(){
  		let params={
  			pageNo:this.current,
  			pageSize:10,
  			msgCategory:this.type,
  		}
  		getNoticeList(params).then((res) => {
	        if (res.code == '0') {
	           this.noticeList = res.result.records;
	           this.total= res.result.total;
	        }
       });
  	},
    goDetail(item) {
      this.$router.push({
        name: "noticeDetail",
        query:{
        	id:item.id,
        	type:this.type,
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 1250px;
  margin: 0 auto;
}
.notice-title {
  font-size: 28px;
  font-weight: bold;
  // color: #9A0B00;
  color: #9A0B00;
  border-bottom: 1px solid #DE764D;
  // border-bottom: 1px solid #214cd9;
  padding-bottom: 12px;
}
// /deep/ .ant-pagination-item-active{
//   border-color:#9A0B00;
// }
// /deep/ .ant-pagination-item-active a{
//   color: #9A0B00;
// }
.list {
  margin-top: 38px;
  padding: 0 12px;
  box-sizing: border-box;
  .notice-item {
    width: 100%;
    border-bottom: 1px dashed #9A0B00;
    padding-bottom: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    .left-name {
      color: #181818;
      width: 80%;
      display: inline-block;
      span {
        margin-left: 8px;
        font-size:18px;
      }
    }
    .right-date {
      float: right;
      font-size:16px;
      color: #4d4d4d;
    }
  }
  .notice-item:hover{
    	.left-name{
        color: #9A0B00;
      }
      .right-date{
        color: #9A0B00;
      }
    }
}
.page {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
</style>